import { MdArrowBack, MdArrowForward } from 'react-icons/md';

const TimelineControls = ({
    onPrev,
    onNext,
    disablePrev,
    disableNext,
}: {
    onPrev: () => void;
    onNext: () => void;
    disablePrev: boolean;
    disableNext: boolean;
}) => (
    <div className="flex justify-end mb-8 gap-6">
        <button
            onClick={onPrev}
            className={`p-2 rounded-sm ${disablePrev
                ? 'opacity-50 cursor-not-allowed bg-system-light-60 text-primary-10'
                : 'bg-brand-green-30 text-primary-100 hover:shadow-custom-dual duration-200 transition-all'
                }`}
            disabled={disablePrev}
        >
            <MdArrowBack size={24} />
        </button>
        <button
            onClick={onNext}
            className={`p-2 rounded-sm ${disableNext
                ? 'opacity-50 cursor-not-allowed bg-system-light-60 text-primary-10'
                : 'bg-brand-green-30 text-primary-100 hover:shadow-custom-dual duration-200 transition-all'
                }`}
            disabled={disableNext}
        >
            <MdArrowForward size={24} />
        </button>
    </div>
);

export default TimelineControls